import { anyRoomListName } from 'owa-locstrings/lib/strings/anyroomlistname.locstring.json';
import loc from 'owa-localize';
import { orchestrator } from 'satcheljs';
import { trace } from 'owa-trace';
import { lazyUpdateUserConfigurationService } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    setUserRoomListConfig,
    searchRoomsUsingPlacesApi,
    getRoomsForList,
    updateUserRoomListConfig,
} from '../actions/calendarRoomActions';

export const VIEW_STATE_CONFIGURATION = 'OWA.ViewStateConfiguration';

export default orchestrator(setUserRoomListConfig, actionMessage => {
    let roomFilters = actionMessage.roomFilters;
    let filtersHaveRoomList: boolean =
        roomFilters?.roomLists &&
        roomFilters.roomLists.length > 0 &&
        !roomFilters.roomLists.some(x => x.email == loc(anyRoomListName));

    // Get Rooms for New List
    if (isFeatureEnabled('cal-advancedRoomBooking')) {
        searchRoomsUsingPlacesApi(roomFilters);
    } else {
        let roomList: string = null;

        if (filtersHaveRoomList) {
            roomList = roomFilters.roomLists[roomFilters.roomLists.length - 1].email;
        }

        getRoomsForList(roomList);
    }

    if (filtersHaveRoomList) {
        const roomList = roomFilters.roomLists[roomFilters.roomLists.length - 1];

        // Update local store
        updateUserRoomListConfig(roomList.name, roomList.email);

        // Update service
        lazyUpdateUserConfigurationService
            .importAndExecute(
                [
                    {
                        key: 'SchedulingLastUsedRoomListEmailAddress',
                        valuetype: 'String',
                        value: [roomList.email],
                    },
                    {
                        key: 'SchedulingLastUsedRoomListName',
                        valuetype: 'String',
                        value: [roomList.name],
                    },
                ],
                VIEW_STATE_CONFIGURATION
            )
            .catch(error => {
                trace.warn('Could not save new selected room list to user configuration');
            });
    }
});
